"use client";

import { useIntersection } from "@/hooks/useIntersection";
import classNames from "@/utils/classNames";

interface AnimatedSectionProps {
  children: React.ReactNode;
  type?: string;
  id?: string;
  className?: string;
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  type,
  id,
  className,
}) => {
  const { ref, isVisible } = useIntersection();

  return (
    <section
      ref={ref}
      id={id}
      data-type={type}
      className={classNames(
        "animated-section",
        isVisible && "visible",
        className
      )}
    >
      {children}
    </section>
  );
};

export default AnimatedSection;
